import {Controller} from "@hotwired/stimulus"
import {get} from "@rails/request.js";

// Connects to data-controller="dashboard-org-modal"
export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    
    this.createOrganization()
  }

  createOrganization() {
    get(this.urlValue, {
      responseKind: "turbo-stream"
    });
  }
}
